module.exports = __webpack_public_path__ + "static/media/The-West-App_Mobile-Banner-343x344px.19ef1611.webp";